export default "__VITE_ASSET__DSHDcvlC__"